import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { closeColor, iconSize } from "../App/GridRenderers";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";


const CloseIcon = ({ mt = 0, onClick, show = true }) => {
    return (
        <div>
            {show && (
                <Stack sx={{ pt: 2, mt: mt }}>
                    <Tooltip title="Close"
                        enterDelay={1000}>
                        <FontAwesomeIcon
                            icon={faCircleXmark}
                            color={closeColor}
                            size={iconSize}
                            onClick={onClick}
                        />
                    </Tooltip>

                </Stack>
            )}
        </div >
    );
};

export default CloseIcon;